const GA_MEASUREMENT_ID = 'G-QLYJ24X5R0';
const CONSENT_STORAGE_KEY = 'cookie_consent';

let gaInitialized = false;

export function getCookieConsent() {
  try {
    return localStorage.getItem(CONSENT_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setCookieConsent(value) {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch {
    // Ignore storage errors (private mode, etc.)
  }
}

export function clearCookieConsent() {
  try {
    localStorage.removeItem(CONSENT_STORAGE_KEY);
  } catch {
    // Ignore storage errors
  }
}

export function hasAnalyticsConsent() {
  return getCookieConsent() === 'accepted';
}

function deleteGaCookies() {
  if (typeof document === 'undefined') return;

  const domains = ['michaelabraun.de', '.michaelabraun.de'];
  const cookies = document.cookie ? document.cookie.split(';') : [];

  cookies.forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (!name.startsWith('_ga')) return;

    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
    });
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  });
}

/**
 * Disables GA, clears consent storage key optionally, and deletes _ga cookies.
 */
export function revokeAnalytics(options = {}) {
  const { removeConsent = false, reload = false } = options;

  if (typeof window !== 'undefined') {
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
  }

  if (removeConsent) {
    clearCookieConsent();
  }

  deleteGaCookies();

  if (reload && typeof window !== 'undefined') {
    window.location.reload();
  }
}

/**
 * Loads gtag.js and configures GA4 only when consent is accepted.
 * Safe to call multiple times — initializes at most once.
 */
export function initGoogleAnalytics() {
  if (gaInitialized || typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;

  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gaInitialized = true;
}

export function trackPageView(path) {
  if (!gaInitialized || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
}
